import React from 'react';

import useDeviceType, { DESKTOP_SCREEN } from '@travel/traveler-core/hooks/useDeviceType';
import usePriceLabel from '@travel/traveler-core/hooks/usePriceLabel';
import { cx } from '@travel/utils';

import Money from 'components/Money';
import PriceLabel from 'components/PriceLabel';

import { Translate } from 'core/translate';
import { ProviderItem, SearchFormQuery } from 'ProviderList-Types';

import styles from './providerBox.module.scss';

type Props = {
  className?: string;
  /** Object of provider data */
  item: ProviderItem;
  /** object of current pge query */
  query?: SearchFormQuery;
  /** Flag to define whether the component will be an expanded style or not */
  isExpandedMapStyle?: boolean;
};

function ProviderPriceBox(props: Props) {
  const { item, query, isExpandedMapStyle } = props;
  const { guestCount, nightLabel } = usePriceLabel(query);
  const isPC = useDeviceType() === DESKTOP_SCREEN;

  if (!item.price) {
    return null;
  }

  return (
    <PriceLabel
      className={cx(props.className, styles.priceBox)}
      price={item.price}
      planPaymentRestrictionFeature={item?.paymentRestrictionFeature}
      hasTotalPriceSuffix={true}
      PriceComponent={props => <Money {...props} />}
      isShowPlanPaymentRestriction={true}
      nightsLabel={nightLabel}
      guestsLabel={
        <Translate
          id="Provider_List.Search.Guests"
          count={guestCount}
          data={{ number_of_guests: guestCount }}
        />
      }
      chargeUnit={<Translate id="Provider_List.Search_Results.Per_Room" />}
      isRowDiscountRateTag={!isExpandedMapStyle && isPC ? true : false}
    />
  );
}

export default ProviderPriceBox;
